<template>
  <div class="snail_nyf_bg">
    <div class="snail_nyf_page">
      <!-- 活动标题 -->
      <div v-wechat-title="'最强蜗牛丨吃！吃的就是年夜饭！'"></div>
      <!-- 头部 -->
      <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' @downloadMonitor="downloadApp" />
      
      <!-- 登录弹窗 -->
      <Login v-if='isShowLogin' noAuthLogin v-on:channelCallback='selectCallback' :gameName="gameName" :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色ID可在游戏中—蜗牛属性—蜗牛信息查看" :channelDist="39">
      </Login>
      <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell' :gameName="gameName">
      </Os>
      
      <!-- 首页进入青瓷游戏LOGO -->
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" name="fade">
        <div @touchmove.prevent :class="['preloading preloading-snail', {'preloading-change': count === 100 }]" v-if="preloadingShow == true">
          <div class="logo"></div>
          <div class="soup">
            <div class="smoke-box">
              <div class="smoke-1"><i></i></div>
              <div class="smoke-2"><i></i></div>
              <div class="smoke-3"><i></i></div>
            </div>
            <div class="pig">
              <i class="pig-1"></i>
              <i class="pig-2"></i>
              <i class="pig-3"></i>
            </div>
            <div class="chopping-board"><i class="chopping-1"></i><i class="chopping-2"></i></div>
          </div>
          <div class="loading_text"></div>
          <div class="ready-box">
            <div class="ready-btn" @click="readyBtn($event)"></div>
          </div>
          <div class="prepare-box">
            <!-- <div class="loading_text"></div> -->
            <div class="loading_bg">
              <div class="loading">
                <div class="loading_line"></div>
              </div>
              <div class="change_text">{{ Math.floor(count) }}%</div>
            </div>
          </div>
          
        </div>
      </transition>
      <!-- 年夜饭内容页 -->
      <div class="snail-nyf-content">
        <!-- 日历 -->
        <div class="calendar" ref="bottomLi6"></div>
        <div class="calendar-transparent" @click="triggerJointClick(7, $event, '邀请函', cdk_list[0].click)"></div>
        <!-- 灯笼 -->
        <div class="lantern lantern-l"></div>
        <div class="lantern lantern-r"></div>
        <!-- 桌子 -->
        <div :class="'table table-' + tableAni" title="桌子">
          <div class="eye"></div>
          <div class="ear"></div>
          <div class="monkey-box">
            <div v-if="is_drew > 0" :class="'monkey monkey-' + randomNumber"></div>
            <div v-else class="monkey-hair" @click="eggReward(6, $event, '猴毛彩蛋', cdk_list[5].click )"></div>
          </div>
          <ul :class="'ul-' + randomNumber">
            <template v-if="drop_list && drop_list.length">
              <li v-for="(item, index) in drop_list"
                  :key="index"
                  :class="[
                    'li-' + (index + 1),
                    'li-' + (index + 1) + '-change-' + item.total,                  
                    'li-' + (index + 1) + '-status-' + cdk_list[4].status,
                    { ['li-' + (index + 1) + '-select']: randomLight === (index + 1) }
                  ]"
                  @click="(index + 1) === 6 && eggReward(5, $event, '彩色的蛋彩蛋', cdk_list[4].click)"><i></i>
              </li>
            </template>
          </ul>
          <ol class="ol-bottom">
            <li :class="'cd-1 cd-1-' + cdk_list[0].status" ref="bottomLi1"></li>
            <li :class="'cd-2 cd-2-' + cdk_list[1].status" ref="bottomLi2"></li>
            <li :class="'cd-3 cd-3-' + cdk_list[2].status" ref="bottomLi3"></li>
            <li :class="'cd-4 cd-4-' + cdk_list[3].status" ref="bottomLi4"></li>
          </ol>
          <ol class="ol-top">
            <li class="cd-1" @click="triggerJointClick(1, $event, '画大饼彩蛋', cdk_list[0].click)"></li>
            <li class="cd-2" @click="triggerJointClick(2, $event, '压岁钱彩蛋', cdk_list[1].click)"></li>
            <li class="cd-3" @click="triggerJointClick(3, $event, '老熟人彩蛋', cdk_list[2].click)"></li>
            <li class="cd-4" @click="triggerJointClick(4, $event, '全家福彩蛋', cdk_list[3].click)"></li>
          </ol>
          <!-- 桌子两侧 -->
          <div class="table-side" title="桌子两侧">
            <div class="role-1"></div>
            <div class="role-2"></div>
            <div class="role-3"></div>
            <div class="role-4"></div>
          </div>
        </div>      

        <div class="reward-times" title="奖励次数" @click="drawLotteryNumber($event)">
          <div>{{times}}</div>
        </div>

        <!-- 底部按钮 -->
        <div class="bottom-nav" title="底部导航">
          <a class="record-btn" @click="recordBtn($event)" href="javascript:;"></a>
          <a :class="['start-btn', times > 0 && is_drew > 0 && startAni == true ? 'start-ani-true' : 'start-ani-false']" @click="lotteryBtn($event);" href="javascript:;"></a>
          <a class="notice-btn" @click="noticeBtn($event);" href="javascript:;"></a>
        </div>
      </div>

      <!-- 规则弹窗 -->
      <div :class="'rule-wrap popup_wrap rule-wrap-' + ruleShow" v-show="ruleShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
          <div class="rule-box popup_wrap-box" v-show="ruleShow"><div class="close-btn" @click="popSwitch('ruleShow', false)"></div></div>
        </transition>
        <div class="close-bg" @click="popSwitch('ruleShow', false)"></div>
      </div>

      <!-- 邀请好友弹窗 -->
      <div :class="'invite-friends-wrap popup_wrap invite-friends-wrap-' + inviteFriendsShow" v-show="inviteFriendsShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
          <div class="invite-friends-box popup_wrap-box" v-show="inviteFriendsShow">
            <div class="close-btn" @click="inviteFriends($event)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('inviteFriendsShow', false)"></div>
      </div>

      <!-- 非微信下的邀请好友弹窗 -->
      <div :class="'copy-friends-wrap popup_wrap copy-friends-wrap-' + copyFriendsShow" v-show="copyFriendsShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
          <div class="copy-friends-box popup_wrap-box" v-show="copyFriendsShow">
            <div class="copy-btn" @click="onCopy('#clipboard-btn', $event)" id="clipboard-btn" data-event="复制邀请链接"
            :data-clipboard-text="clipInfo + shareLink"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('copyFriendsShow', false)"></div>
      </div>

      <!-- 非微信下分享引导弹窗 -->
      <div :class="'share-wrap popup_wrap share-wrap-' + shareShow" v-show="shareShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
          <div class="share-img popup_wrap-box" v-show="shareShow"></div>
        </transition>
        <div class="close-bg" @click="popSwitch('shareShow', false)"></div>
      </div>

      <!-- 增加次数弹窗 -->
      <div :class="'add-wrap popup_wrap add-wrap-' + addShow" v-show="addShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
          <div class="add-box popup_wrap-box" v-show="addShow">
            <a class="confirm-btn" href="javascript:;" @click="addNum()"></a>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('addShow', false)"></div>
      </div>

      <!-- 抽奖弹窗 -->
      <div :class="'reward-wrap popup_wrap reward-wrap-' + rewardShow" v-show="rewardShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
          <div :class="'reward-box popup_wrap-box reward-' + randomNumber + ' dialogue-' + randomDialogue" v-show="rewardShow">
            <a class="confirm-btn" href="javascript:;" @click="popSwitch('rewardShow', false)"></a>
            <a :class="'hidden-confirm-btn hidden-'+hiddenBtnClick+'-ani'" href="javascript:;" @click="hiddenBtnAni()"></a>
          </div>
        </transition>
      </div>

      <!-- 奖励信息弹窗 -->
      <div :class="'reward-list-wrap popup_wrap reward-list-wrap-' + rewardListShow" v-show="rewardListShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
          <div class="reward-list-box popup_wrap-box" v-show="rewardListShow">
            <div class="list">
              <div v-if="record_list.length == 0">暂无数据</div>
              <ul v-else>
                <li v-for="(item, index) in record_list" :key="index" v-if="!(item.type == '2' && !item.cdk)">
                  <div class="box-l">
                    <span v-if="item.remark">{{ item.remark }}</span>
                    <template v-else>
                      <span v-if="item.type == '2'">密令:<b class="colorRed">{{ item.cdk }}</b></span>
                      <span v-else-if="item.type == '3'">CDK:<b class="colorBlue" @click="onCopy('#clipboard-cdk-btn', $event)" id="clipboard-cdk-btn" :data-clipboard-text="item.cdk">{{ item.cdk }}</b></span>
                    </template>
                  </div>
                  <div class="box-r">
                    <span>{{ item.created_at }}</span>
                  </div>
                </li>
              </ul>
            </div>
            <a class="confirm-btn" href="javascript:;" @click="popSwitch('rewardListShow', false)"></a>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('rewardListShow', false)"></div>
      </div>

      <!-- 任务弹窗 -->
      <div :class="'task-wrap popup_wrap task-wrap-' + taskShow" v-show="taskShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
          <div class="task-box popup_wrap-box" v-show="taskShow">
            <div class="task-list">
              <li v-for="(item, index) in task_list" :key="index">
                <div class="info">
                  <span>{{ item.name }}</span>
                  <span>{{ item.num }} / 3</span>
                </div>
                <div class="btn">
                  <a :class="'task-' + item.status + '-btn reach-btn'" href="javascript:;" :title="getTaskStatusTitle(item.status)" @click="participatingTask(item.id, $event, item.status)"></a>
                </div>               
              </li>
            </div>
            <a class="confirm-btn" href="javascript:;" @click="popSwitch('taskShow', false)"></a>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('taskShow', false)"></div>
      </div>

      <!-- 彩蛋弹窗 -->
      <div :class="'egg-reward-wrap popup_wrap egg-reward-wrap-' + eggRewardShow" v-show="eggRewardShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
          <div :class="'egg-reward-box popup_wrap-box egg-' + egg_id + ' egg-' + egg_state + ' click-' + egg_click" v-show="eggRewardShow">
            <p>获得兑换码<span>{{ eggRewardCdk }}</span></p>
            <a class="confirm-btn" href="javascript:;" @click="popSwitch('eggRewardShow', false)"></a>
            <a class="invitation-btn" href="javascript:;" @click="invitationLink($event);"></a>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('eggRewardShow', false)"></div>
      </div>

      <!-- 助力弹窗 -->
      <div :class="'help-wrap popup_wrap help-wrap-' + helpShow" v-show="helpShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
          <div class="help-box popup_wrap-box" v-show="helpShow">
            <div>
              <a class="l-btn" href="javascript:;" @click="acceptInvitationBtn()"></a>
              <a class="r-btn" href="javascript:;" @click="acceptInvitationBtn()"></a>
            </div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('helpShow', false)"></div>
      </div>

      <!-- 微信下载 -->
      <div class="wechat_download_wrap popup_wrap" v-show="wxLoadShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
          :duration="{ enter: 1000 }">
          <div class="wx_download_wrap_content" @click="wxLoadShow = false"></div>
        </transition>
        <div class="close-bg" v-if="wxLoadShow" @click="wxLoadShow = false"></div>
      </div>

      <!-- 阻止点击弹出-弹窗 -->
      <div @touchmove.prevent :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

    </div>
  </div>
</template>
<script>

import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';

import Header from '../Header/index.vue';
import { headerConfig } from "../headerConfig";
import Clipboard from 'clipboard';
import { onGetInitDataAPI, lotteryDataAPI, taskDataAPI, eggRewardDataAPI, assistanceDataAPI, downloadApps } from '../api';
import { wechatBrowser, getRandomString, getTimeStamp, buriedLogger, analysisParams } from '@/utils/utils';
export default {
  name: 'nyf',
  components: {
    Header,
    Login,
    Os
  },
  data() {
    return {
      count: 0, // 预加载进度-开发中关闭为100
      headerConfig,
      gameName: "snail",
      loginTypes: ["sms", "password", "channel"],
      downloadUrl: 'http://snail.qingcigame.com/official/',
      taptapUrl: 'https://tap.cn/tm3lTYBt?channel=rep-rep_nlo5ha7ptsr',
      preloadingShow: true,
      randomNumber: 6,  // 默认随机按钮,默认为6
      randomLight: '',  // 随机光动画
      egg_id: 1,  // 彩蛋id
      egg_state: false, // 彩蛋状态
      tableAni: false,  // 桌子动画
      clickcom: 0,  // 点击次数
      times: 0, // 抽奖次数
      is_drew: 7, // 是否抽奖的数量，小于等于0说明全部抽过了
      record_list: [],  // 中奖信息
      task_list: [],  // 任务列表
      cdk_list: [
        { status: 0, click: 0 },
        { status: 0, click: 0 },
        { status: 0, click: 0 },
        { status: 0, click: 0 },
        { status: 0, click: 0 },
        { status: 0, click: 0 },
      ], // 奖励信息
      drop_list: [
        {id: 1, name: "橙色攻击蘑菇*1", rate: 200, num: 0, limit: 0, total: 1},
        {id: 2, name: "龙珠*1", rate: 50, num: 0, limit: 0, total: 1},
        {id: 3, name: "白蝌蚪*2026", rate: 15, num: 0, limit: 0, total: 1},
        {id: 4, name: "培养液*10", rate: 5, num: 0, limit: 0, total: 1},
        {id: 5, name: "绿贵-薪资保密协议*1", rate: 0, num: 8, limit: 1, total: 1},
        {id: 6, name: "史诗源兽蛋*1", rate: 0, num: 0, limit: 0, total: 1},
        {id: 7, name: "黑蝌蚪*20000", rate: 0, num: 0, limit: 0, total: 1},
        {id: 8, name: "抽奖券*8", rate: 0, num: 0, limit: 0, total: 1}
      ], // 奖品信息
      active_Info: {}, // 活动信息
      user_info: {}, // 用户信息
      isUserInfo: false, // 是否获取用户信息
      shareLink: '',  // 分享链接      
      clipInfo: '', // 复制使用的文案
      params: '', // 分享参数
      url_type: '', // 分享类型
      egg_click: 0, // 彩蛋点击次数
      randomDialogue: 0, // 随机对话
      hiddenBtnClick: 0, // 隐藏按钮动画
      // 弹窗相关
      preventShow: false, // 阻止点击弹出
      wxLoadShow: false, //微信下载弹窗
      shareShow: false, // 分享弹窗
      rewardShow: false,  // 奖励弹窗
      rewardListShow: false, // 奖励信息弹窗
      taskShow: false,  // 任务弹窗
      inviteFriendsShow: false, // 邀请好友弹窗
      copyFriendsShow: false, // 非微信下的邀请好友弹窗
      eggRewardShow: false, // 彩蛋弹窗
      ruleShow: false, // 规则弹窗
      helpShow: false, // 帮助弹窗
      addShow: false, // 增加次数弹窗
      startAni: false, // 开始抽奖动画
      // 默认下载包
      downloadUrls: {
        android_url: 'https://download4.qcplay.com/apk-v2/qc-kol-1169712.apk',
        ios_url: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1169724&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
      },
      // 音乐相关
      audioPlayers: {},
      audioMap: {
        bg: require('@/assets/images/active/snail/nyf/mp3/bg_loop.mp3'),
        kaixuan: require('@/assets/images/active/snail/nyf/mp3/kaixuan.mp3'),
        btn: require('@/assets/images/active/snail/nyf/mp3/btn.mp3'),
        fama: require('@/assets/images/active/snail/nyf/mp3/fama.mp3'),
        bonus_receive: require('@/assets/images/active/snail/nyf/mp3/bonus_receive.mp3'),
        surprise: require('@/assets/images/active/snail/nyf/mp3/surprise.mp3'),
        probe: require('@/assets/images/active/snail/nyf/mp3/probe.mp3'),
      },
    };
  },
  created() {
    // 预加载
    setTimeout(() => {
      this.incrementTo100();
    }, 5);
    this.isSetShare(false);
    const params = analysisParams(window.location.href);
    const { download_id } = params;
    
    download_id && downloadApps({ download_id, title: 'title' }).then((res) => {
      if (res.code === 200) {
        this.downloadUrls = res.data
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      
      this.params = analysisParams(window.location.href);
      this.url_type = this.params.type;      
      this.friendId = this.params.friend_id;
      const { protocol, host } = window.location;
      const pcLink = `${protocol}//${host}/snail/nyf/pc`;
      // 检测是否pc端
      // if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = pcLink;

      const bl = buriedLogger('snail', '蜗牛_年夜饭h5');  // 埋点
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum('蜗牛_年夜饭h5_活动页统计');
      }, 200);
    })
  },
  methods: {
    // 预加载
    incrementTo100() {
      const target = 100;
      const duration = 4850; // 持续时间6秒
      const stepTime = duration / target; // 每一步的时间间隔
      const that = this;
      const intervalId = setInterval(() => {
        that.count += 1;
        if (that.count >= target) {
          clearInterval(intervalId); // 当达到100时停止计时器
        }
      }, stepTime);
    },
    // 获取用户信息
    getLoginContainer() {
      onGetInitDataAPI().then(response => {
        if (Number(response.code) === 200) {
          this.active_Info = response.data.activity || [];
          this.user_info = response.data.user_info || [];
          this.cdk_list = response.data.activity.cdk_list || [];
          this.is_drew = response.data.activity.is_drew;  // 是否抽过数量
          if(this.is_drew > 0) {
            setTimeout(() => {
              this.startAni = true;
            }, 1000);
          } 
          this.drop_list = response.data.activity.drop_list;  // 掉落列表
          this.times = response.data.activity.times;  // 抽奖次数
          this.record_list = response.data.activity.record_list;  // 奖励列表
          this.task_list = response.data.activity.task_list;  // 任务列表
          this.isSetShare(false);
          this.friendHelp();
          // 回调
          this.onInitDataCallback(response);  
          return
        } 
        this.friendHelp();
        Number(response.code) !== 401 && this.onToast(response.message)
      }).catch((err) => {
        this.onToast('服务器出错啦')
      })
    },
    // 点击进入游戏
    readyBtn(e) {
      this.getLoginContainer();
      this.triggerBtnScale(e);
      this.preloadingShow = false;
      this.playAudio('btn');
      this.playAudioBg('bg');
      this.logger.sum('蜗牛_年夜饭h5_点击进入游戏按钮');
    },
    // 好友助力
    friendHelp() {
      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }
      if(this.friendId !== undefined) {
        this.helpShow = true;
      }
    },
    // 接受邀请
    acceptInvitationBtn() {
      this.logger.sum('蜗牛_年夜饭h5_助力按钮统计');
      assistanceDataAPI({ invite_code: this.friendId }).then((res) => {
        if (res.code === 200) {
          const currentUrl = window.location.href;
          const baseUrl = currentUrl.split('?')[0];  
          window.history.replaceState({}, '', baseUrl); 
          this.helpShow = false;
          this.friendId = undefined;
          this.logger.sum('蜗牛_年夜饭h5_成功助力次数');
        }
      })
    },
    // 点击下载
    downloadLink() {

      if (this.url_type == '' || this.url_type == undefined) {
        this.logger.sum('蜗牛_年夜饭h5_点击首屏下载按钮');
        setTimeout(() => {
          window.location.href = this.taptapUrl;
        }, 200);
      } else {
        this.logger.sum('蜗牛_年夜饭h5_点击首屏下载按钮(qc-kol-1145353)');
        setTimeout(() => {
          window.location.href = '//download4.qcplay.com/apk-v2/' + this.url_type + '.apk';
        }, 200);
      }

    },
    // 获取抽奖次数
    drawLotteryNumber(e) {
      this.triggerBtnScale(e);
      this.playAudio('btn');
      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }
      this.logger.sum('蜗牛_年夜饭h5_点击获取抽奖次数按钮');
      this.popSwitch('taskShow', true);
    },
    // 弹窗状态-开or关
    popSwitch(name, state) {
      // 奖励列表
      if ((name == 'rewardListShow' && state)) {
        if (this.user_info.account === undefined || this.user_info.account === '') {
          this.changeLoginPopup(true);
        } else {
          this[name] = state;
        }
        return
      }
      // 抽奖次数弹窗
      if (name == 'shareShow') {
        if (!state) {
          this.isSetShare(false);
        }
      }
      this[name] = state;
    },
    hiddenBtnAni() {
      this.hiddenBtnClick ++;
    },
    // 复制链接
    onCopy(copyName, e) {
      this.triggerBtnScale(e);
      this.playAudio('btn');
      this.copyPageLink(); // 复制页面链接
      var _this = this;
      const clipboard = new Clipboard(copyName);
      clipboard.on('success', (e) => {
        _this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        _this.onToast('复制失败');
      });
      this.logger.sum('蜗牛_年夜饭h5，复制成功');
    },
    // 任务类型
    taskType(type_id) {
      taskDataAPI({ task_id: type_id })
        .then(response => {
          if (Number(response.code) === 200) {
            this.getLoginContainer();
            return
          }
          if (type_id == 1) return
          this.onToast(response.message)
          this.preventShow = false;
        }).catch((err) => {
          this.onToast('服务器出错啦')
        })
    },
    // 生成复制链接
    copyPageLink() {
      const { protocol, host } = window.location;
      console.log(this.user_info.account);
      this.clipInfo = '【最强蜗牛】前两天没理你是我不对，现在我在Peter的商务饭局上，可以帮我点一下吗：';
      this.shareLink = `${protocol}//${host}/snail/nyf/enter${getRandomString()}?friend_id=` + this.active_Info.invite_code;
      this.logger.sum('蜗牛_年夜饭h5_点击邀请按钮');
    },
    // 抽奖添加次数
    addNum() {
      this.addShow = false;
      this.taskShow = true;
      this.logger.sum('蜗牛_年夜饭h5_点击增加次数按钮');
    },
    // 点击抽奖按钮
    lotteryBtn(e) {
      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.playAudio('btn');
        this.changeLoginPopup(true);
        return
      }
      if (this.times <= 0) {
        this.playAudio('btn');
        this.addShow = true;
        return
      }
      this.playAudio('kaixuan');
      
      this.triggerBtnScale(e);
      this.startAni = false;
      setTimeout(() => {
        this.preventShow = true;
      }, 300);
      lotteryDataAPI().then(response => {
        if (Number(response.code) === 200) {
          this.pauseAudio('bg');
          setTimeout(() => {
            this.playAudio('probe');
          }, 500);
          this.logger.sum('蜗牛_年夜饭h5_人均【开炫】次数');
          this.tableAni = true;
          this.randomDrawing(response.data.drop_info);
          return
        }
        setTimeout(() => {
          this.preventShow = false;
          this.playAudioBg('bg');
        }, 2000);
        this.onToast(response.message)
      }).catch((err) => {
        this.onToast('服务器出错啦')
      })
    },
    // 随机抽奖
    randomDrawing(prize_id) {
      let prevNum = null;
      let count = 0;
      let countMax = 20;
      let interval = 400; // 初始速度为2秒一次
      let intervalId = null;
      var _this = this;

      function getRandomNum(min, max) {
        let num = Math.floor(Math.random() * (max - min + 1)) + min;
        if (num === prevNum) {
          return getRandomNum(min, max);
        }
        return num;
      }

      function setRandomNum() {
        if (count === countMax) {
          clearInterval(intervalId);
          _this.randomDialogue = Math.floor(Math.random() * 10) + 1;
          _this.randomNumber = prize_id;
          _this.randomLight = prize_id;
          _this.tableAni = false;
          console.log('中奖结果', prize_id);
          _this.playAudio('bonus_receive');
          setTimeout(() => {
            _this.randomLight = '';
            _this.rewardShow = true;
            _this.playAudio('bg');
            _this.getLoginContainer();
            setTimeout(() => { _this.preventShow = false; }, 1000);
          }, 1000);
          return;
        }

        if (count === Math.floor(countMax / 3)) {
          clearInterval(intervalId);
          interval = 200; // 中间三分之一的速度是1秒一次
          intervalId = setInterval(setRandomNum, interval);
        } else if (count === Math.floor(2 * countMax / 3)) {
          clearInterval(intervalId);
          interval = 400; // 最后三分之一速度是2秒一次
          intervalId = setInterval(setRandomNum, interval);
        }

        prevNum = getRandomNum(1, 8);
        _this.randomNumber = prevNum;
        _this.randomLight = prevNum;
        console.log('当前结果', prevNum);
        count++;
        _this.playAudio('surprise');
      }

      intervalId = setInterval(setRandomNum, interval);
    },
    // 获奖记录按钮
    recordBtn(e) {
      this.logger.sum('蜗牛_年夜饭h5_【获奖记录】按钮');
      this.popSwitch('rewardListShow', true);
      this.playAudio('btn');
      this.triggerBtnScale(e);
    },
    // 须知按钮
    noticeBtn(e) {
      this.logger.sum('蜗牛_年夜饭h5_【查看须知】按钮');
      this.popSwitch('ruleShow', true);
      this.playAudio('btn');
      this.triggerBtnScale(e);
    },
    // 立即摇人
    inviteFriends(e) {
      this.logger.sum('蜗牛_年夜饭h5_立刻摇人按钮');
      this.popSwitch('inviteFriendsShow', false);
      this.playAudio('btn');
      this.triggerBtnScale(e);

      if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
        // 微信浏览器
        this.popSwitch('taskShow', false);
        this.popSwitch('shareShow', true);
        this.isSetShare(true);
      } else {
        // 其他浏览器
        this.popSwitch('copyFriendsShow', true);
        this.isSetShare(false);
      }
    },
    playAudio(audioName) {
      const audio = new Audio(this.audioMap[audioName]);
      audio.play();
    },
    playAudioBg(audioName) {
      if (!this.audioPlayers[audioName]) {
        this.audioPlayers[audioName] = new Audio(this.audioMap[audioName]);
        this.audioPlayers[audioName].loop = true;
      }
      this.audioPlayers[audioName].play();
    },
    pauseAudio(audioName) {
      if (this.audioPlayers[audioName]) {
        this.audioPlayers[audioName].pause();
      }
    },
    // 是否领取过奖励
    participatingTask(id, e, status) {
      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }      
      // 任务状态为未完成
      if(status !== 2) {
        this.triggerBtnScale(e);
        this.playAudio('btn');
        // 每日登录活动页面,任务一
        if (id == 1) {
          this.taskType([id]);  // 领取任务
          this.logger.sum('蜗牛_年夜饭h5_任务统计-每日登录活动页面');
        }
        // 每日登录游戏,任务二
        if (id == 2) {
          this.taskType([id]);  // 领取任务
          this.logger.sum('蜗牛_年夜饭h5_任务统计-每日登录1次游戏');
        }
        // 每日登录游戏,任务三
        if (id == 3) {
          // 这里做js的微信检查，如果是微信内点击则alter1，如果是其他浏览器点击则alert2
          this.popSwitch('inviteFriendsShow', true);
          this.logger.sum('蜗牛_年夜饭h5_任务统计-邀请好友上桌吃饭');
          this.logger.sum('蜗牛_年夜饭h5_分享任务按钮');
        }
      }      
    },
    triggerJointClick(id, event, eggName, clickState) {
      // 1. 触发底部对应 li 的点击事件
      const bottomLiRef = this.$refs[`bottomLi${id}`];
      if (bottomLiRef) {
        bottomLiRef.classList.add('btn-scale-ani');
        this.preventShow = true;
        bottomLiRef.addEventListener('animationend', function handler() {
          bottomLiRef.classList.remove('btn-scale-ani');
          bottomLiRef.removeEventListener('animationend', handler);
        });
        setTimeout(() => { this.preventShow = false }, 200);
        bottomLiRef.click();
      }
      // 2. 执行原有的彩蛋逻辑
      this.eggReward(id, event, eggName, clickState);
    },
    // 彩蛋密令
    eggReward(id, e, loggerName, click) {
      this.triggerBtnScale(e);
      this.playAudio('btn');
      
      if (this.user_info.account === undefined || this.user_info.account === '') {
        this.changeLoginPopup(true);
        return
      }
      if(id == 7) {
        this.egg_id = id;
        this.popSwitch('eggRewardShow', true);
        this.logger.sum(loggerName);
        return
      }
      if(id !== 2) {
        this.cdkEggType(id, loggerName, click);
        return
      }
      this.playAudio('fama');
      // 如果已经完成
      if (this.cdk_list[1].status == 1) {
        this.cdkEggType(id, loggerName, click);
        return
      }
      
      if(this.clickcom == 30 || this.clickcom == 60) this.onToast('砝码好像松动了一些...');
      if(this.clickcom < 99) {
        // 当彩蛋序号是2的时候，需要点击至少30次
        this.clickcom ++;
        console.log('click', this.clickcom);
      } else {
        // 这时候要发起一次api请求
        this.cdkEggType(id, loggerName, click);
        return
      }      
    },
    // cdk+彩蛋类型
    cdkEggType(id, loggerName, click) {
      Indicator.open();
      console.log('埋点：', loggerName);
      this.logger.sum(loggerName);
      this.preventShow = true;
      var cdk_id = id;
      // 如果已经领取过“高端彩蛋”
      if (this.record_list.some(item => item.reward_id === 7 && item.type === 2 )) this.egg_click = 3;
      if (this.egg_click >= 1 && id == 5) cdk_id = 7;
      eggRewardDataAPI({ cdk_id: cdk_id, click_num: click })
        .then(response => {
          setTimeout(() => {
            Indicator.close();
            if (Number(response.code) === 200 || Number(response.code) === 405) {
              this.preventShow = false;
              if(id == 5) {
                if(this.egg_click < 3) {
                  this.egg_click++;
                }
              }
              this.egg_id = id;
              this.egg_cdk = response.data.cdk;
              this.popSwitch('eggRewardShow', true);
              this.getLoginContainer();
            }
            if (Number(response.code) === 200) {
              this.egg_state = false;
              return
            }
            if (Number(response.code) === 405) {
              this.egg_state = true;
              return
            }
            this.onToast(response.message);
            setTimeout(() => {
              this.preventShow = false;
            }, 200);
          }, 400);
        }).catch((err) => {
          this.onToast('服务器出错啦')
          Indicator.close();
        })
    },
    // 接受邀请按钮
    invitationLink(e) {
      this.triggerBtnScale(e);
      this.playAudio('btn');
      this.logger.sum('蜗牛_年夜饭h5_下班出发按钮');
      window.location.href = 'https://l.taptap.cn/aeTYXKlu?channel=rep-rep_luj9w6tumz0';
    },
    // 微信分享
    isSetShare(is_wx) {
      const { protocol, host } = window.location;
      var enterLink = `${protocol}//${host}/snail/nyf/enter${getRandomString()}`;
      if (is_wx == true) {
        enterLink = `${protocol}//${host}/snail/nyf/enter${getRandomString()}` + '?friend_id=' + this.active_Info.invite_code; 
      }
      console.log('enterLink', enterLink);
      this.setShare({
        link: enterLink,
        title: '最强蜗牛丨吃！吃的就是年夜饭！',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/7FDNuo4e1g2R1xzvYW2rNhm4BN89Q8sY2bUyDhqa.jpeg',
        desc: '嘎嘣脆的龙珠，爆汁的源兽蛋！给蜗爷溜着边儿吃！',
      })
    },
    // 选择角色后
    selectCallback() {
      this.clearActiveInfo();
      this.getLoginContainer();
    },
    // TAG: 相关业务方法
    onInvite() {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
    },
    // 注销
    osCancell() {
      this.clearActiveInfo();
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.active_Info = [];
      this.user_info = [];
      this.isUserInfo = true;
      this.egg_id = 1;  // 彩蛋id
      this.egg_state = false; // 彩蛋状态
      this.startAni = false; // 抽奖按钮动画
      this.clickcom = 0;  // 点击次数
      this.hiddenBtnClick = 0; // 隐藏按钮动画
      this.times = 0;
      this.is_drew = 7;
      this.randomNumber = 6;
      this.egg_click = 0; // 彩蛋点击次数
      this.randomDialogue = 0; // 随机对话
      this.record_list = [];
      this.task_list = [];
      this.cdk_list = [
        { status: 0, click: 0 },
        { status: 0, click: 0 },
        { status: 0, click: 0 },
        { status: 0, click: 0 },
        { status: 0, click: 0 },
        { status: 0, click: 0 },
      ];
      this.drop_list = [
        {id: 1, name: "橙色攻击蘑菇*1", rate: 200, num: 0, limit: 0, total: 1},
        {id: 2, name: "龙珠*1", rate: 50, num: 0, limit: 0, total: 1},
        {id: 3, name: "白蝌蚪*2026", rate: 15, num: 0, limit: 0, total: 1},
        {id: 4, name: "培养液*10", rate: 5, num: 0, limit: 0, total: 1},
        {id: 5, name: "绿贵-薪资保密协议*1", rate: 0, num: 8, limit: 1, total: 1},
        {id: 6, name: "史诗源兽蛋*1", rate: 0, num: 0, limit: 0, total: 1},
        {id: 7, name: "黑蝌蚪*20000", rate: 0, num: 0, limit: 0, total: 1},
        {id: 8, name: "抽奖券*8", rate: 0, num: 0, limit: 0, total: 1}
      ];
    },
    getTaskStatusTitle(status) {
      const titles = {
        0: '没完成过',
        1: '可领取',
        2: '今日已领取',
        3: '达到上限按钮置灰'
      };
      return titles[status] || '';
    },
    // 下载调用
    downloadApp () {
      const isWechat = wechatBrowser()
      if (isWechat) {
        this.wxLoadShow = true
      } else {
        const linkObj = this.downloadUrls;
        const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
        const targetLink = isIOS ? linkObj.ios_url : linkObj.android_url;
        this.logger.sum('蜗牛_年夜饭h5_【下载】跳转按钮');

        if (targetLink) {
          setTimeout(() => {
            window.location.href = targetLink
          }, 200)
        }
      }
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 通用按钮缩放动画
    triggerBtnScale(e) {
      const el = e.currentTarget;
      el.classList.add('btn-scale-ani');
      this.preventShow = true;
      el.addEventListener('animationend', function handler() {
        el.classList.remove('btn-scale-ani');
        el.removeEventListener('animationend', handler);
      });
      setTimeout(() => { this.preventShow = false }, 250);
    },
    loginSuccess () {
      this.getLoginContainer();
    },
    loginCallback(response) {
      localStorage.setItem('nyf_token', response.data.access_token)
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  },
  computed: {
    eggRewardCdk() {
      if (this.record_list && this.record_list.length > 0) {
        const reward = this.record_list.find(item => item.reward_id === 2);
        if (reward && reward.cdk) {
          return reward.cdk;
        }
      }
      return '';
    },
    
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          console.log('注销的时候')
          this.osCancell()
        } else if (
          newValue.role_id !== oldValue.role_id ||
          newValue.account !== oldValue.account
        ) {
          // 数据初始化
          // this.getLoginContainer()
        }
      }
    }
  },
};
</script>

<style lang="less">
@import url("./index.less");
</style>
 


// WEBPACK FOOTER //
// src/pages/snail/nyf/index/index.vue